import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { Subscription } from 'rxjs';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-turns-desk-schedules-card',
  templateUrl: './turns-desk-schedules-card.component.html',
  styleUrls: ['./turns-desk-schedules-card.component.scss']
})
export class TurnsDeskSchedulesCardComponent implements OnInit, OnDestroy {

  @Input() desk;
  @Input() schedules;
  @Input() existingSchedules;
  existingSchedule = new FormControl(null);
  deleteScheduleSubscription: Subscription;
  updateSchedulesSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
              private snackbarService: SnackBarService,
              private router: Router,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() { }

  public addSchedule() {
    if (this.existingSchedule.value === null) {
      this.router.navigate(['schedule'], { relativeTo: this.activatedRoute });
    } else {
      this.desksTurnsService.linkExistingDeskSchedule(this.existingSchedule.value.InternalId, this.desk.InternalId).pipe(
        tap(o => this.desksTurnsService.refreshDesk()),
        tap(o => this.existingSchedule.patchValue(null))
      ).subscribe();
    }
  }

  public editSchedule(schedule) {
    this.router.navigate(['schedule', schedule.InternalId], { relativeTo: this.activatedRoute });
  }

  public deleteSchedule(schedule) {
    this.updateSchedulesSubscription = this.desksTurnsService.deleteDeskSchedule(schedule.InternalId, this.desk.InternalId).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update desk success', 'success');
        this.desksTurnsService.refreshDesk();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  ngOnDestroy() {
    if (this.deleteScheduleSubscription) { this.deleteScheduleSubscription.unsubscribe(); }
    if (this.updateSchedulesSubscription) { this.updateSchedulesSubscription.unsubscribe(); }
  }
}
